import { render, staticRenderFns } from "./looksurvey.vue?vue&type=template&id=08d4a564&scoped=true&"
import script from "./looksurvey.vue?vue&type=script&lang=js&"
export * from "./looksurvey.vue?vue&type=script&lang=js&"
import style0 from "./looksurvey.vue?vue&type=style&index=0&id=08d4a564&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d4a564",
  null
  
)

export default component.exports